import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap'
import ViewImageItem from './ViewImageItem'
import CheckVariants from './CheckVariants'
import MarkWrongDesign from './MarkWrongDesign'
import { Tag, notification } from 'antd'
import { Fragment } from 'react'

class CheckLineItem extends React.Component {
    _handleSyncDesign = (designKey) => {
        const { product } = this.props
        const { pos } = product

        this.props.onSyncDesign(pos, designKey)
    }

    openNotification = () => {
        const { id } = this.props
        notification.error({
            message: (
                <div>
                    <h3 className='mb-0'>{`#${id}`}</h3>
                    <h3>{`Có mặt chưa in`}</h3>
                </div>
            ),
            placement: 'topRight',
            duration: 0,
        })
    }

    componentWillUnmount() {
        notification.destroy()
    }

    render() {
        const { id, product, isBrandKitTag, reset, haveScanToCheck, onChangeId, hiddenButtonQC = false } = this.props
        const { mockUpFront, mockUpBack, designFront, designBack, type, designSleeveLeft, designSleeveRight, tags, brand_name, brand_rule } = product
        const { tags: ruleTags = [] } = { ...brand_rule }
        const branding = ruleTags.length > 0 ? ruleTags.filter(i => i.type === 'branding') : []
        const isSpecialTag = Array.isArray(tags) && tags.includes('priority-store')
        const isErrorQC = Array.isArray(tags) && tags.includes('errQC')
        const isQC = !isErrorQC && haveScanToCheck
        const { status } = { ...product }
        const isQCHT2d = window.location.pathname === '/check'

        return (
            <div>
                <Card className='CheckLineItem'>
                    <CardHeader className='bg-warning text-white'>
                        <h2>#{id} - {type}</h2>
                        <CheckVariants product={product} />
                        {
                            isSpecialTag && <Tag color="#ff0000" className='Special p-2'>Đặc biệt</Tag>
                        }
                        {
                            isBrandKitTag && <Tag color="#108ee9" className="Special ml-2 p-2">Đơn có Brand Kit</Tag>
                        }
                        {isErrorQC &&
                            <h3 className='my-0 mx-3'>*Item lỗi</h3>
                        }
                        {isQC &&
                            <h3 className='my-0 mx-3'>*Item hoàn thành</h3>
                        }
                    </CardHeader>
                    {(!!brand_name && (!!branding && branding.length > 0)) &&
                        <h3 className="brandName mx-3 my-2 d-flex">
                            <span className="Name font-weight-bold">{brand_name}:</span>
                            <span className="font-weight-bold px-1" style={{ minWidth: 101 }}>Branding -</span>
                            {!!branding && branding.length > 0 &&
                                <Fragment>
                                    <span className="Branding d-flex flex-wrap">
                                        {branding.map((item, index) => (
                                            index ? `, ${item.name}` : item.name
                                        ))}
                                    </span>
                                </Fragment>
                            }
                        </h3>
                    }
                    <CardBody>
                        <Row>
                            <Col lg={6}>
                                <ViewImageItem
                                    title={'MẶT TRƯỚC'} mockUp={mockUpFront}
                                    onSync={this._handleSyncDesign}
                                    designKey="designFront" design={designFront}
                                    designSleeve={designSleeveLeft !== ''}
                                    color={product.color}
                                />
                            </Col>
                            <Col lg={6}>
                                <ViewImageItem
                                    title={'MẶT SAU'} mockUp={mockUpBack}
                                    onSync={this._handleSyncDesign}
                                    designKey="designBack" design={designBack}
                                    designSleeve={designSleeveRight !== ''}
                                    color={product.color}
                                />
                            </Col>

                            {designSleeveLeft && (
                                <Col lg={6}>
                                    <ViewImageItem
                                        title={'TAY TRÁI'} mockUp={mockUpFront}
                                        onSync={this._handleSyncDesign}
                                        designKey="designSleeveLeft" design={designSleeveLeft}
                                        designSleeve={designSleeveLeft !== ''}
                                        color={product.color}
                                    />
                                </Col>
                            )}

                            {designSleeveRight && (
                                <Col lg={6}>
                                    <ViewImageItem
                                        title={'TAY PHẢI'} mockUp={mockUpBack}
                                        onSync={this._handleSyncDesign}
                                        designKey="designSleeveRight" design={designSleeveRight}
                                        designSleeve={designSleeveRight !== ''}
                                        color={product.color}
                                    />
                                </Col>
                            )}
                        </Row>
                    </CardBody>
                </Card>
                {
                    !hiddenButtonQC &&
                    <MarkWrongDesign id={id} reset={reset} onChangeId={onChangeId} product={product} />
                }
                
                {isQCHT2d && status && status !== 'completed' ? this.openNotification() : notification.destroy()}
            </div>
        )
    }
}

CheckLineItem.propTypes = {
    onSyncDesign: PropTypes.func.isRequired,
}

export default CheckLineItem
